import Symbol from 'core-js/es6/symbol';

import invariant from 'invariant';

import _ from 'lodash';
import ko from 'knockout';

const views = Symbol('views');
const computedViews = Symbol('computedViews');

function getView (target, viewName) {
	const view = target[views][viewName];
	invariant(
		view,
		`View named \`${viewName}\` is not attached to the observable`,
	);
	return view;
}

ko.extenders.view = function view (target, options) {
	target[computedViews] = target[computedViews] || {};
	target[views] = target[views] || {};
	_.extend(target[views], options);

	function read (view) {
		return view.read.call(target, target());
	}

	function write (view, writeValue) {
		target(view.write.call(target, writeValue));
	}

	target.view = function (...args) {
		const [viewName, ...rest] = args;
		const view = getView(target, viewName);

		if (args.length === 1) {
			return read(view);
		}
		return write(view, ...rest);
	};

	target.computedView = function (viewName) {
		getView(target, viewName);
		if (!target[computedViews][viewName]) {
			const kv = require('rgs-knockout-validation').default;
			target[computedViews][viewName] = ko.pureComputed({
				read: () => target.view(viewName),
				write: (v) => target.view(viewName, v),
			}).extend({
				inheritEditable: target,
				...(kv.utils.isValidatable(target)
					? { followValidation: target } : {}),
			});
		}
		return target[computedViews][viewName];
	};
};
